module.exports = [
    {
        "label": "Pacific/Auckland|NZMT NZST NZST NZDT",
        "value": "Pacific/Auckland"
    },
    {
        "label": "Australia/Sydney|AEST AEDT",
        "value": "Australia/Sydney"
    },
    {
        "label": "Australia/Adelaide|ACST ACDT",
        "value": "Australia/Adelaide"
    },
    {
        "label": "Australia/Brisbane|AEST AEDT",
        "value": "Australia/Brisbane"
    },
    {
        "label": "Europe/Paris",
        "value": "Europe/Paris"
    },
    {
        "label": "Europe/Berlin",
        "value": "Europe/Berlin"
    },
    {
        "label": "Asia/Jakarta",
        "value": "Asia/Jakarta"
    },
    {
        "label": "Asia/Jayapura",
        "value": "Asia/Jayapura"
    },
    {
        "label": "Asia/Kolkata",
        "value": "Asia/Kolkata"
    },
    {
        "label": "Asia/Manila",
        "value": "Asia/Manila"
    },
    {
        "label": "Asia/Hong_Kong",
        "value": "Asia/Hong_Kong"
    },
    {
        "label": "Asia/Singapore",
        "value": "Asia/Singapore"
    }

]